import {handleRippleEffect} from '@/utils';

describe('Utils - DOM - generatedInputNameAndId', () => {
    it('should create a joy-ripple-effect element once, even with multiple clicks', () => {
        document.body.innerHTML = template();
        const target = document.querySelector('button') as HTMLButtonElement;

        const e = dispatchClick();
        handleRippleEffect(e, target);

        expect(getRippleEl(target).length).toBe(1);

        handleRippleEffect(e, target);
        handleRippleEffect(e, target);
        handleRippleEffect(e, target);
        handleRippleEffect(e, target);
        handleRippleEffect(e, target);

        expect(getRippleEl(target).length).toBe(1);
    });
});

function template() {
    return `<button type="button">Button !</button>`;
}

function dispatchClick() {
    const e = new MouseEvent('click');
    window.dispatchEvent(e);
    return e;
}

function getRippleEl(target: HTMLElement) {
    return Array.from(target.querySelectorAll('.joy-ripple-effect'));
}
